// Product data with actual images
export const productsData = [
  // Toilet Seats & Sanitaryware
  {
    id: 1,
    name: "Aerin",
    category: "toilet",
    type: "Premium Toilet Seat",
    image: "/images/Aerin.png",
    description: "Premium quality toilet seat with modern design and durable construction."
  },
  {
    id: 2,
    name: "Aeron", 
    category: "toilet",
    type: "Comfort Toilet",
    image: "/images/Aeron.png",
    description: "Ergonomic toilet design with superior comfort and water efficiency."
  },
  {
    id: 3,
    name: "Alaska",
    category: "toilet", 
    type: "Arctic White Toilet",
    image: "/images/Alaska.png",
    description: "Sleek white toilet with contemporary styling and easy maintenance."
  },
  {
    id: 4,
    name: "Alba Rimless",
    category: "toilet",
    type: "Rimless Toilet",
    image: "/images/Alba-Rimless.png", 
    description: "Modern rimless toilet design for enhanced hygiene and easy cleaning."
  },
  {
    id: 5,
    name: "Aldo",
    category: "toilet",
    type: "Classic Toilet",
    image: "/images/Aldo.png",
    description: "Traditional design toilet with reliable performance and durability."
  },
  {
    id: 6,
    name: "Alis",
    category: "toilet",
    type: "Designer Toilet", 
    image: "/images/Alis.png",
    description: "Contemporary designer toilet with premium finish and modern aesthetics."
  },
  {
    id: 7,
    name: "Almora",
    category: "toilet",
    type: "Mountain Series",
    image: "/images/Almora.png",
    description: "Inspired by mountain aesthetics, offering strength and elegance."
  },
  {
    id: 8,
    name: "Alon",
    category: "toilet", 
    type: "Compact Toilet",
    image: "/images/Alon.png",
    description: "Space-saving compact toilet perfect for smaller bathrooms."
  },

  // Wash Basins & Pedestals
  {
    id: 9,
    name: "Ample",
    category: "basin",
    type: "Large Basin",
    image: "/images/Ample.png", 
    description: "Spacious wash basin with ample bowl space and modern design."
  },
  {
    id: 10,
    name: "Anglo Indian",
    category: "basin",
    type: "Traditional Basin",
    image: "/images/Anglo Indian S_P.png",
    description: "Traditional Anglo-Indian style basin with heritage design elements."
  },
  {
    id: 11,
    name: "Arika",
    category: "basin",
    type: "Designer Basin",
    image: "/images/Arika.png",
    description: "Elegant designer basin with contemporary styling and premium finish."
  },
  {
    id: 12,
    name: "Astron", 
    category: "basin",
    type: "Modern Basin",
    image: "/images/Astron.png",
    description: "Futuristic design basin with clean lines and modern appeal."
  },

  // Luxury Collection
  {
    id: 13,
    name: "Audi",
    category: "luxury",
    type: "Luxury Toilet",
    image: "/images/Audi.png",
    description: "Premium luxury toilet inspired by automotive excellence and precision."
  },
  {
    id: 14,
    name: "Benz Plus", 
    category: "luxury",
    type: "Premium Plus",
    image: "/images/Benz Plus.png",
    description: "Top-tier luxury sanitaryware with enhanced features and premium materials."
  },
  {
    id: 15,
    name: "Benz",
    category: "luxury",
    type: "Luxury Series",
    image: "/images/Benz.png",
    description: "Luxury collection inspired by German engineering and design excellence."
  },

  // Classic & Traditional
  {
    id: 16,
    name: "Berlin",
    category: "classic",
    type: "European Style",
    image: "/images/Berlin.png",
    description: "European-inspired design with classic elegance and modern functionality."
  },
  {
    id: 17,
    name: "Baby",
    category: "compact",
    type: "Compact Size",
    image: "/images/Baby.png",
    description: "Compact sanitaryware perfect for small spaces and guest bathrooms."
  },
  {
    id: 18,
    name: "Bruck Plus",
    category: "classic",
    type: "Enhanced Classic", 
    image: "/images/Bruck Plus.png",
    description: "Classic design with enhanced features and improved functionality."
  },
  {
    id: 19,
    name: "Bruck",
    category: "classic",
    type: "Traditional Design",
    image: "/images/Bruck.png",
    description: "Traditional styling with time-tested design and reliable performance."
  },
  {
    id: 20,
    name: "Bruna",
    category: "designer",
    type: "Contemporary Design",
    image: "/images/Bruna.png",
    description: "Contemporary design with sleek lines and modern aesthetics."
  },

  // Modern Collection  
  {
    id: 21,
    name: "Caliber",
    category: "modern",
    type: "Precision Design",
    image: "/images/Caliber.png",
    description: "Precision-engineered sanitaryware with exact specifications and quality."
  },
  {
    id: 22,
    name: "Cassa",
    category: "modern", 
    type: "Box Design",
    image: "/images/Cassa.png",
    description: "Geometric box-inspired design with modern cubic aesthetics."
  },
  {
    id: 23,
    name: "Cherry",
    category: "designer",
    type: "Elegant Design",
    image: "/images/Cherry.png",
    description: "Elegant design inspired by natural beauty and organic forms."
  },
  {
    id: 24,
    name: "City Pan",
    category: "urban",
    type: "Urban Design", 
    image: "/images/City Pan.png",
    description: "Urban-inspired design perfect for modern city living spaces."
  },
  {
    id: 25,
    name: "Coco",
    category: "natural",
    type: "Natural Finish",
    image: "/images/coco.png",
    description: "Natural finish sanitaryware with earth-inspired tones and textures."
  },

  // Designer Series
  {
    id: 26,
    name: "Colado",
    category: "designer",
    type: "Artistic Design",
    image: "/images/Colado.png",
    description: "Artistic design with unique sculptural elements and creative aesthetics."
  },
  {
    id: 27,
    name: "Coral",
    category: "marine",
    type: "Marine Inspired",
    image: "/images/Coral.png",
    description: "Marine-inspired design with flowing curves and oceanic aesthetics."
  },
  {
    id: 28,
    name: "Croma Rimless Plus",
    category: "rimless",
    type: "Enhanced Rimless",
    image: "/images/Croma rimless plus.png",
    description: "Advanced rimless technology with enhanced hygiene and cleaning ease."
  },
  {
    id: 29,
    name: "Croms Plus",
    category: "chrome",
    type: "Chrome Finish",
    image: "/images/Croms Plus.png",
    description: "Premium chrome finish with mirror-like surface and lasting durability."
  },
  {
    id: 30,
    name: "Cruse",
    category: "nautical",
    type: "Nautical Design",
    image: "/images/Cruse.png", 
    description: "Nautical-inspired design with maritime elegance and coastal charm."
  },

  // Romantic & Elegant
  {
    id: 31,
    name: "Cupid",
    category: "romantic",
    type: "Romantic Design",
    image: "/images/Cupid.png",
    description: "Romantic design with soft curves and elegant finishing touches."
  },
  {
    id: 32,
    name: "Daisy",
    category: "floral",
    type: "Floral Inspired",
    image: "/images/Daisy.png",
    description: "Floral-inspired design with delicate details and natural beauty."
  },
  {
    id: 33,
    name: "Decor",
    category: "decorative",
    type: "Decorative Design",
    image: "/images/Decor.png",
    description: "Decorative elements with intricate patterns and artistic details."
  },
  {
    id: 34,
    name: "Demis",
    category: "compact",
    type: "Semi-Compact",
    image: "/images/Demis.png",
    description: "Semi-compact design offering space efficiency without compromising comfort."
  },
  {
    id: 35,
    name: "Deniam",
    category: "textured",
    type: "Textured Finish",
    image: "/images/Deniam.png",
    description: "Unique textured finish with tactile appeal and visual interest."
  },

  // Elegant Collection
  {
    id: 36,
    name: "Elan",
    category: "elegant",
    type: "Sophisticated Design",
    image: "/images/Elan.png",
    description: "Sophisticated design with refined elegance and premium craftsmanship."
  },
  {
    id: 37,
    name: "Elegant",
    category: "elegant",
    type: "Classic Elegance",
    image: "/images/Elegant.png",
    description: "Classic elegance with timeless appeal and sophisticated styling."
  },
  {
    id: 38,
    name: "Element Rimless",
    category: "rimless",
    type: "Elemental Rimless",
    image: "/images/Element Rimless.png",
    description: "Fundamental rimless design with essential features and clean aesthetics."
  },
  {
    id: 39,
    name: "Element",
    category: "basic",
    type: "Essential Design",
    image: "/images/Element.png",
    description: "Essential design with fundamental features and reliable performance."
  },
  {
    id: 40,
    name: "Elina",
    category: "feminine",
    type: "Graceful Design", 
    image: "/images/Elina.png",
    description: "Graceful design with feminine touches and delicate aesthetics."
  },

  // Geometric & Modern
  {
    id: 41,
    name: "Elips",
    category: "geometric",
    type: "Elliptical Design",
    image: "/images/Elips.png",
    description: "Elliptical geometry with smooth curves and mathematical precision."
  },
  {
    id: 42,
    name: "Elite",
    category: "premium",
    type: "Elite Series",
    image: "/images/Elite.png",
    description: "Elite series with premium materials and superior craftsmanship."
  },
  {
    id: 43,
    name: "Emola",
    category: "emotional",
    type: "Expressive Design",
    image: "/images/Emola.png",
    description: "Expressive design that creates emotional connection through form and function."
  },
  {
    id: 44,
    name: "Ento",
    category: "entrance",
    type: "Entry Level",
    image: "/images/Ento.png",
    description: "Entry-level sanitaryware with quality features at an accessible price point."
  },
  {
    id: 45,
    name: "Ethan",
    category: "masculine",
    type: "Strong Design",
    image: "/images/Ethan.png",
    description: "Strong masculine design with bold lines and powerful presence."
  },

  // EWC (European Water Closet) Collection
  {
    id: 46,
    name: "EWC Concealed",
    category: "concealed",
    type: "Concealed Cistern",
    image: "/images/EWC Concealed.png",
    description: "European water closet with concealed cistern for clean, modern aesthetics."
  },
  {
    id: 47,
    name: "EWC",
    category: "european",
    type: "European Style",
    image: "/images/EWC.png",
    description: "Traditional European water closet with classic design and functionality."
  },

  // Feminine Collection
  {
    id: 48,
    name: "Femina",
    category: "feminine",
    type: "Feminine Design",
    image: "/images/Femina.png",
    description: "Designed with feminine aesthetics featuring gentle curves and elegant details."
  },
  {
    id: 49,
    name: "Fiona",
    category: "fairy",
    type: "Fairy Tale Design",
    image: "/images/Fiona.png",
    description: "Fairy tale inspired design with whimsical elements and magical appeal."
  },
  {
    id: 50,
    name: "Flora",
    category: "floral",
    type: "Botanical Design",
    image: "/images/Flora.png",
    description: "Botanical-inspired design with natural flora elements and organic shapes."
  },

  // Location-Inspired Series
  {
    id: 51,
    name: "Florida",
    category: "tropical",
    type: "Tropical Design",
    image: "/images/Florida.png",
    description: "Tropical design inspired by Florida's coastal beauty and relaxed lifestyle."
  },
  {
    id: 52,
    name: "Fogo",
    category: "fire",
    type: "Dynamic Design",
    image: "/images/Fogo.png",
    description: "Dynamic design with fiery aesthetics and bold, energetic styling."
  },
  {
    id: 53,
    name: "Grace",
    category: "graceful",
    type: "Graceful Elegance",
    image: "/images/Grace.png",
    description: "Graceful elegance with flowing lines and sophisticated charm."
  },
  {
    id: 54,
    name: "Helix",
    category: "spiral",
    type: "Spiral Design",
    image: "/images/Helix.png",
    description: "Spiral-inspired design with helical elements and mathematical beauty."
  },

  // ITA Collection (Italian Inspired)
  {
    id: 55,
    name: "ITA Bhama",
    category: "italian",
    type: "Italian Beauty",
    image: "/images/ITA Bhama.png",
    description: "Italian-inspired design celebrating beauty and Mediterranean aesthetics."
  },
  {
    id: 56,
    name: "ITA Blue Berry",
    category: "italian",
    type: "Blue Berry Finish",
    image: "/images/ITA BLue Berry.png",
    description: "Italian design with unique blue berry finish and vibrant coloring."
  },
  {
    id: 57,
    name: "ITA Dark Brown",
    category: "italian",
    type: "Dark Brown Finish",
    image: "/images/ITA Dark Brown.png",
    description: "Rich dark brown finish with Italian craftsmanship and premium materials."
  },
  {
    id: 58,
    name: "ITA Olive Green",
    category: "italian",
    type: "Olive Green Finish",
    image: "/images/ITA Olive Green.png",
    description: "Elegant olive green finish inspired by Italian countryside aesthetics."
  },
  {
    id: 59,
    name: "ITA Smoke Grey",
    category: "italian",
    type: "Smoke Grey Finish",
    image: "/images/ITA Smoke Grey.png",
    description: "Sophisticated smoke grey finish with Italian design sensibilities."
  },
  {
    id: 60,
    name: "ITA",
    category: "italian",
    type: "Italian Classic",
    image: "/images/ITA.png",
    description: "Classic Italian design with traditional Mediterranean styling and elegance."
  },

  // Character-Named Series
  {
    id: 61,
    name: "Jack",
    category: "character",
    type: "Strong Character",
    image: "/images/Jack.png",
    description: "Strong character design with bold features and reliable performance."
  },
  {
    id: 62,
    name: "Jazz",
    category: "musical",
    type: "Musical Inspiration",
    image: "/images/Jazz.png",
    description: "Musical inspiration with rhythmic patterns and harmonious design elements."
  },
  {
    id: 63,
    name: "Jeff",
    category: "character",
    type: "Friendly Design",
    image: "/images/Jeff.png",
    description: "Friendly design with approachable aesthetics and comfortable functionality."
  },
  {
    id: 64,
    name: "Jenny",
    category: "character",
    type: "Charming Design",
    image: "/images/Jenny.png",
    description: "Charming design with delightful details and endearing characteristics."
  },
  {
    id: 65,
    name: "Kelos",
    category: "unique",
    type: "Distinctive Design",
    image: "/images/Kelos.png",
    description: "Distinctive design with unique characteristics and standout features."
  },

  // K-Series
  {
    id: 66,
    name: "Krevito",
    category: "creative",
    type: "Creative Design",
    image: "/images/Krevito.png",
    description: "Creative design with innovative features and artistic expression."
  },

  // L-Series
  {
    id: 67,
    name: "Lara",
    category: "adventure",
    type: "Adventurous Design",
    image: "/images/Lara.png",
    description: "Adventurous design with bold exploration and pioneering aesthetics."
  },
  {
    id: 68,
    name: "Lavasa",
    category: "hill",
    type: "Hill Station Design",
    image: "/images/Lavasa.png",
    description: "Hill station inspired design with elevated aesthetics and mountain charm."
  },
  {
    id: 69,
    name: "Lavis",
    category: "luxury",
    type: "Lavish Design",
    image: "/images/Lavis.png",
    description: "Lavish design with opulent features and luxurious styling elements."
  },
  {
    id: 70,
    name: "Letina Plus",
    category: "enhanced",
    type: "Enhanced Features",
    image: "/images/Letina plus.png",
    description: "Enhanced version with additional features and improved functionality."
  },
  {
    id: 71,
    name: "Letina",
    category: "standard",
    type: "Standard Excellence",
    image: "/images/Letina.png",
    description: "Standard excellence with proven design and reliable performance."
  },
  {
    id: 72,
    name: "Libra",
    category: "balanced",
    type: "Balanced Design",
    image: "/images/Libra.png",
    description: "Perfectly balanced design with harmonious proportions and symmetry."
  },
  {
    id: 73,
    name: "Linia",
    category: "linear",
    type: "Linear Design",
    image: "/images/Linia.png",
    description: "Linear design with clean straight lines and geometric precision."
  },
  {
    id: 74,
    name: "Loft",
    category: "urban",
    type: "Loft Style",
    image: "/images/Loft.png",
    description: "Industrial loft style with urban aesthetics and contemporary appeal."
  },
  {
    id: 75,
    name: "Loral",
    category: "floral",
    type: "Floral Elegance",
    image: "/images/Loral.png",
    description: "Floral elegance with botanical motifs and natural beauty."
  },
  {
    id: 76,
    name: "Lorens",
    category: "noble",
    type: "Noble Design",
    image: "/images/Lorens.png",
    description: "Noble design with aristocratic elegance and refined sophistication."
  },
  {
    id: 77,
    name: "Lorenz",
    category: "noble",
    type: "Distinguished Design",
    image: "/images/Lorenz.png",
    description: "Distinguished design with noble characteristics and prestigious appeal."
  },
  {
    id: 78,
    name: "Lunar",
    category: "celestial",
    type: "Moon Inspired",
    image: "/images/Lunar.png",
    description: "Moon-inspired design with celestial beauty and ethereal aesthetics."
  },

  // M-Series
  {
    id: 79,
    name: "Mark",
    category: "signature",
    type: "Signature Design",
    image: "/images/Mark.png",
    description: "Signature design with distinctive marks and recognizable characteristics."
  },
  {
    id: 80,
    name: "Marvel",
    category: "amazing",
    type: "Marvelous Design",
    image: "/images/Marvel.png",
    description: "Marvelous design with amazing features and wonder-inspiring aesthetics."
  },
  {
    id: 81,
    name: "Max",
    category: "maximum",
    type: "Maximum Comfort",
    image: "/images/Max.png",
    description: "Maximum comfort design with optimized ergonomics and superior functionality."
  },
  {
    id: 82,
    name: "Medrid",
    category: "spanish",
    type: "Spanish Inspired",
    image: "/images/Medrid.png",
    description: "Spanish-inspired design with Mediterranean flair and cultural richness."
  },
  {
    id: 83,
    name: "Merry",
    category: "joyful",
    type: "Joyful Design",
    image: "/images/Merry.png",
    description: "Joyful design with cheerful aesthetics and uplifting characteristics."
  },
  {
    id: 84,
    name: "Metro",
    category: "metropolitan",
    type: "Metropolitan Style",
    image: "/images/Metro.png",
    description: "Metropolitan style with urban sophistication and city-inspired design."
  },

  // Mini Series
  {
    id: 85,
    name: "Mini Berlin",
    category: "compact",
    type: "Compact Berlin",
    image: "/images/Mini Berlin.png",
    description: "Compact version of Berlin design, perfect for smaller spaces."
  },
  {
    id: 86,
    name: "Mini ITA",
    category: "compact",
    type: "Compact Italian",
    image: "/images/Mini ITA.png",
    description: "Compact Italian design with space-saving features and authentic styling."
  },
  {
    id: 87,
    name: "Mini Jazz",
    category: "compact",
    type: "Compact Musical",
    image: "/images/Mini Jazz.png",
    description: "Compact musical inspiration with rhythmic design in a smaller footprint."
  },
  {
    id: 88,
    name: "Mini Sophie",
    category: "compact",
    type: "Compact Elegance",
    image: "/images/Mini Sopie.png",
    description: "Compact elegance with Sophie's sophisticated design in a smaller size."
  },
  {
    id: 89,
    name: "Mini Steela",
    category: "compact", 
    type: "Compact Steel",
    image: "/images/Mini steela.png",
    description: "Compact steel design with metallic aesthetics in a space-saving format."
  },

  // More M-Series
  {
    id: 90,
    name: "Monalisa",
    category: "artistic",
    type: "Artistic Masterpiece",
    image: "/images/Monalisa.png",
    description: "Artistic masterpiece inspired by classical art and timeless beauty."
  },
  {
    id: 91,
    name: "Moris Copy",
    category: "replica",
    type: "Heritage Replica",
    image: "/images/Moris copy.png",
    description: "Heritage replica design preserving traditional craftsmanship and styling."
  },
  {
    id: 92,
    name: "Moris Pedestal",
    category: "pedestal",
    type: "Pedestal Design",
    image: "/images/Moris Pedestal.png",
    description: "Elegant pedestal design with classical proportions and stable base."
  },
  {
    id: 93,
    name: "Moris",
    category: "heritage",
    type: "Heritage Design",
    image: "/images/Moris.png",
    description: "Heritage design with traditional values and time-honored aesthetics."
  },
  {
    id: 94,
    name: "Myara",
    category: "precious",
    type: "Precious Design",
    image: "/images/Myara.png",
    description: "Precious design with valuable aesthetics and treasured characteristics."
  },

  // N-Series
  {
    id: 95,
    name: "Nero",
    category: "dark",
    type: "Dark Elegance",
    image: "/images/Nero.png",
    description: "Dark elegance with mysterious beauty and sophisticated black aesthetics."
  },
  {
    id: 96,
    name: "Noram",
    category: "normal",
    type: "Standard Design",
    image: "/images/Noram.png",
    description: "Standard design with normal proportions and everyday functionality."
  },
  {
    id: 97,
    name: "Nova",
    category: "stellar",
    type: "Star Bright",
    image: "/images/Nova.png",
    description: "Star-bright design with nova-like brilliance and celestial inspiration."
  },

  // O-Series
  {
    id: 98,
    name: "Olivia",
    category: "nature",
    type: "Natural Beauty",
    image: "/images/Olivia.png",
    description: "Natural beauty with olive-inspired aesthetics and organic charm."
  },
  {
    id: 99,
    name: "Olwin",
    category: "friend",
    type: "Friendly Design",
    image: "/images/Olwin.png",
    description: "Friendly design with approachable characteristics and welcoming appeal."
  },
  {
    id: 100,
    name: "Omini",
    category: "universal",
    type: "Universal Design",
    image: "/images/Omini.png",
    description: "Universal design suitable for all spaces and diverse applications."
  },

  // Pan Series (Orissa)
  {
    id: 101,
    name: "Orissa Pan 20",
    category: "regional",
    type: "Regional Pan 20",
    image: "/images/Orrisa Pan 20.png",
    description: "Regional design from Orissa with cultural authenticity and local appeal."
  },
  {
    id: 102,
    name: "Orissa Pan 23",
    category: "regional",
    type: "Regional Pan 23",
    image: "/images/Orrisa Pan 23.png",
    description: "Enhanced regional design with updated features and improved functionality."
  },

  // P-Series with Pedestals
  {
    id: 103,
    name: "Parish Pedestal",
    category: "pedestal",
    type: "Community Pedestal",
    image: "/images/Parish Pedestal.png",
    description: "Community-inspired pedestal design with social connectivity and shared values."
  },
  {
    id: 104,
    name: "Parish",
    category: "community",
    type: "Community Design",
    image: "/images/Parish.png",
    description: "Community design fostering connection and shared bathroom experiences."
  },
  {
    id: 105,
    name: "Plaza",
    category: "public",
    type: "Public Space Design",
    image: "/images/Plaza.png",
    description: "Public space design with open aesthetics and communal appeal."
  },
  {
    id: 106,
    name: "Prime",
    category: "premium",
    type: "Prime Quality",
    image: "/images/Prime.png",
    description: "Prime quality with first-class materials and superior craftsmanship."
  },
  {
    id: 107,
    name: "Prism",
    category: "geometric",
    type: "Prismatic Design",
    image: "/images/Prism.png",
    description: "Prismatic design with geometric complexity and light-refracting beauty."
  },
  {
    id: 108,
    name: "Pyoral",
    category: "fire",
    type: "Fire Design",
    image: "/images/Pyoral.png",
    description: "Fire-inspired design with passionate aesthetics and dynamic energy."
  },

  // R-Series
  {
    id: 109,
    name: "Recta",
    category: "rectangular",
    type: "Rectangular Design",
    image: "/images/Recta.png",
    description: "Rectangular design with straight edges and geometric precision."
  },
  {
    id: 110,
    name: "Repose Pedestal",
    category: "pedestal",
    type: "Restful Pedestal",
    image: "/images/Repose Pedestal.png",
    description: "Restful pedestal design promoting relaxation and peaceful experiences."
  },
  {
    id: 111,
    name: "Repose",
    category: "restful",
    type: "Restful Design",
    image: "/images/Repose.png",
    description: "Restful design encouraging relaxation and peaceful bathroom moments."
  },
  {
    id: 112,
    name: "Rio Plus",
    category: "tropical",
    type: "Enhanced Tropical",
    image: "/images/Rio plus.png",
    description: "Enhanced tropical design with vibrant Rio-inspired aesthetics and features."
  },
  {
    id: 113,
    name: "Rio",
    category: "tropical",
    type: "Tropical Carnival",
    image: "/images/Rio.png",
    description: "Tropical carnival design with festive Brazilian flair and joyful colors."
  },
  {
    id: 114,
    name: "Roca",
    category: "rock",
    type: "Rock Solid",
    image: "/images/Roca.png",
    description: "Rock-solid design with geological inspiration and enduring strength."
  },
  {
    id: 115,
    name: "Rome",
    category: "classical",
    type: "Roman Classical",
    image: "/images/ROme.png",
    description: "Roman classical design with ancient architectural beauty and imperial grandeur."
  },
  {
    id: 116,
    name: "Root",
    category: "organic",
    type: "Root System",
    image: "/images/Root.png",
    description: "Organic root system design with natural growth patterns and earth connection."
  },
  {
    id: 117,
    name: "Rosa",
    category: "floral",
    type: "Rose Inspired",
    image: "/images/Rosa.png",
    description: "Rose-inspired design with romantic florals and delicate beauty."
  },
  {
    id: 118,
    name: "Roxy",
    category: "energetic",
    type: "Energetic Design",
    image: "/images/Roxy.png",
    description: "Energetic design with dynamic appeal and vibrant characteristics."
  },
  {
    id: 119,
    name: "Rubic",
    category: "puzzle",
    type: "Puzzle Design",
    image: "/images/Rubic.png",
    description: "Puzzle-inspired design with cubic complexity and intellectual appeal."
  },
  {
    id: 120,
    name: "Ruby",
    category: "precious",
    type: "Precious Gem",
    image: "/images/Ruby.png",
    description: "Precious gem design with ruby-red inspiration and valuable aesthetics."
  },

  // S-Series
  {
    id: 121,
    name: "Scolla",
    category: "school",
    type: "Educational Design",
    image: "/images/Scolla.png",
    description: "Educational design suitable for institutional and learning environments."
  },
  {
    id: 122,
    name: "Scoot",
    category: "mobile",
    type: "Mobile Design",
    image: "/images/Scoot.png",
    description: "Mobile-inspired design with dynamic movement and modern transportation aesthetics."
  },
  {
    id: 123,
    name: "Simi Pedestal",
    category: "pedestal",
    type: "Simple Pedestal",
    image: "/images/Simi pedestal.png",
    description: "Simple pedestal design with minimalist aesthetics and clean lines."
  },
  {
    id: 124,
    name: "Simi",
    category: "simple",
    type: "Simple Design",
    image: "/images/Simi.png",
    description: "Simple design with uncomplicated aesthetics and straightforward functionality."
  },
  {
    id: 125,
    name: "Slavia",
    category: "slavic",
    type: "Slavic Design",
    image: "/images/SLavia.png",
    description: "Slavic-inspired design with Eastern European cultural elements and heritage."
  },
  {
    id: 126,
    name: "Slog",
    category: "industrial",
    type: "Industrial Design",
    image: "/images/Slog.png",
    description: "Industrial design with rugged aesthetics and working-class appeal."
  },
  {
    id: 127,
    name: "Soft",
    category: "gentle",
    type: "Gentle Design",
    image: "/images/Soft.png",
    description: "Gentle design with soft curves and comforting characteristics."
  },
  {
    id: 128,
    name: "Sophia",
    category: "wisdom",
    type: "Wise Design",
    image: "/images/Sophia.png",
    description: "Wise design inspired by Sophia's wisdom and intelligent aesthetics."
  },
  {
    id: 129,
    name: "Sophie",
    category: "sophisticated",
    type: "Sophisticated Design",
    image: "/images/Sopie.png",
    description: "Sophisticated design with refined elegance and cultured appeal."
  },
  {
    id: 130,
    name: "Spoon",
    category: "curved",
    type: "Curved Design",
    image: "/images/Spoon.png",
    description: "Curved design inspired by spoon shapes with ergonomic comfort."
  },
  {
    id: 131,
    name: "Square",
    category: "geometric",
    type: "Square Design",
    image: "/images/Square.png",
    description: "Perfect square design with geometric precision and mathematical beauty."
  },
  {
    id: 132,
    name: "Star",
    category: "stellar",
    type: "Star Design",
    image: "/images/Star.png",
    description: "Star-inspired design with celestial beauty and stellar performance."
  },
  {
    id: 133,
    name: "Steela",
    category: "steel",
    type: "Steel Design",
    image: "/images/Steela.png",
    description: "Steel-inspired design with metallic aesthetics and industrial strength."
  },
  {
    id: 134,
    name: "Storm",
    category: "weather",
    type: "Storm Design",
    image: "/images/Storm.png",
    description: "Storm-inspired design with powerful weather aesthetics and dynamic energy."
  },
  {
    id: 135,
    name: "Swin",
    category: "swimming",
    type: "Swimming Design",
    image: "/images/Swin.png",
    description: "Swimming-inspired design with aquatic flow and water sports aesthetics."
  },
  {
    id: 136,
    name: "Swiss",
    category: "precision",
    type: "Swiss Precision",
    image: "/images/Swiss.png",
    description: "Swiss precision design with exact engineering and reliable quality."
  },

  // T-Series
  {
    id: 137,
    name: "Tera",
    category: "earth",
    type: "Earth Design",
    image: "/images/Tera.png",
    description: "Earth-inspired design with terrestrial beauty and natural grounding."
  },
  {
    id: 138,
    name: "Thio",
    category: "unique",
    type: "Unique Design",
    image: "/images/Thio.png",
    description: "Unique design with distinctive characteristics and individual personality."
  },
  {
    id: 139,
    name: "Thron",
    category: "royal",
    type: "Throne Design",
    image: "/images/Thron.png",
    description: "Throne-inspired design with royal majesty and regal commanding presence."
  },
  {
    id: 140,
    name: "Titanic",
    category: "massive",
    type: "Massive Design",
    image: "/images/Titanic.png",
    description: "Massive design with titanic proportions and legendary scale."
  },

  // U-Series
  {
    id: 141,
    name: "Ultra",
    category: "extreme",
    type: "Ultra Modern",
    image: "/images/Ultra.png",
    description: "Ultra-modern design pushing boundaries with extreme innovation and futuristic appeal."
  },

  // V-Series
  {
    id: 142,
    name: "Vegas",
    category: "entertainment",
    type: "Entertainment Design",
    image: "/images/Vegas.png",
    description: "Entertainment design with Las Vegas glamour and show-stopping appeal."
  },

  // W-Series
  {
    id: 143,
    name: "Wena Plus",
    category: "enhanced",
    type: "Enhanced Comfort",
    image: "/images/Wena plus.png",
    description: "Enhanced comfort design with additional features and improved user experience."
  },
  {
    id: 144,
    name: "Wena",
    category: "comfort",
    type: "Comfort Design",
    image: "/images/Wena.png",
    description: "Comfort-focused design prioritizing user well-being and ergonomic satisfaction."
  },

  // Y-Series
  {
    id: 145,
    name: "York",
    category: "english",
    type: "English Heritage",
    image: "/images/York.png",
    description: "English heritage design with Yorkshire tradition and British elegance."
  },
  {
    id: 146,
    name: "Yuga",
    category: "era",
    type: "Era Design",
    image: "/images/Yuga.png",
    description: "Era-defining design representing a significant period in sanitaryware evolution."
  },

  // Z-Series
  {
    id: 147,
    name: "Zinnia",
    category: "floral",
    type: "Flower Power",
    image: "/images/Zinnia.png",
    description: "Flower-power design with zinnia-inspired beauty and garden freshness."
  },
  {
    id: 148,
    name: "Zita",
    category: "final",
    type: "Ultimate Design",
    image: "/images/Zita.png",
    description: "Ultimate design representing the pinnacle of sanitaryware innovation and style."
  },

  // Faucet Collections - Creta Series
  {
    id: 149,
    name: "Creta Basin Mixer",
    category: "faucet",
    type: "Basin Mixer",
    image: "/images/newProducts/creta/1.jpg",
    description: "Premium Creta series basin mixer with elegant chrome finish and smooth operation."
  },
  {
    id: 150,
    name: "Creta Sink Mixer",
    category: "faucet",
    type: "Sink Mixer",
    image: "/images/newProducts/creta/2.jpg",
    description: "Durable Creta sink mixer designed for kitchen and utility areas."
  },
  {
    id: 151,
    name: "Creta Wall Mixer",
    category: "faucet",
    type: "Wall Mixer",
    image: "/images/newProducts/creta/3.jpg",
    description: "Wall-mounted Creta mixer with contemporary design and precision engineering."
  },

  // Faucet Collections - Metro Series
  {
    id: 152,
    name: "Metro Basin Mixer",
    category: "faucet",
    type: "Basin Mixer",
    image: "/images/newProducts/metro/1.jpg",
    description: "Metropolitan style basin mixer with sleek lines and modern aesthetics."
  },
  {
    id: 153,
    name: "Metro Sink Cock",
    category: "faucet",
    type: "Sink Cock",
    image: "/images/newProducts/metro/2.jpg",
    description: "Metro series sink cock with robust construction and easy maintenance."
  },

  // Faucet Collections - Olive Series
  {
    id: 154,
    name: "Olive Basin Mixer",
    category: "faucet",
    type: "Basin Mixer",
    image: "/images/newProducts/olive/1.jpg",
    description: "Olive series basin mixer with nature-inspired design and premium finish."
  },
  {
    id: 155,
    name: "Olive Wall Mixer",
    category: "faucet",
    type: "Wall Mixer",
    image: "/images/newProducts/olive/2.jpg",
    description: "Elegant Olive wall mixer combining functionality with sophisticated styling."
  },

  // Faucet Collections - Myra Series
  {
    id: 156,
    name: "Myra Basin Mixer",
    category: "faucet",
    type: "Basin Mixer",
    image: "/images/newProducts/myra/1.jpg",
    description: "Myra series basin mixer with graceful curves and smooth water flow."
  },
  {
    id: 157,
    name: "Myra Pillar Cock",
    category: "faucet",
    type: "Pillar Cock",
    image: "/images/newProducts/myra/2.jpg",
    description: "Classic Myra pillar cock with timeless design and reliable performance."
  },

  // Shower Systems - Bend Shower
  {
    id: 158,
    name: "Bend Shower Arm",
    category: "shower",
    type: "Shower Arm",
    image: "/images/newProducts/bendshower/1.jpg",
    description: "Flexible bend shower arm for adjustable shower head positioning."
  },
  {
    id: 159,
    name: "Bend Shower Set",
    category: "shower",
    type: "Complete Set",
    image: "/images/newProducts/bendshower/2.jpg",
    description: "Complete bend shower set with all mounting accessories included."
  },

  // Shower Systems - Overhead Shower
  {
    id: 160,
    name: "Overhead Shower Round",
    category: "shower",
    type: "Overhead Shower",
    image: "/images/newProducts/overheadshower/1.jpg",
    description: "Round overhead shower with rainfall effect for luxurious bathing experience."
  },
  {
    id: 161,
    name: "Overhead Shower Square",
    category: "shower",
    type: "Overhead Shower",
    image: "/images/newProducts/overheadshower/2.jpg",
    description: "Square overhead shower with modern design and wide water coverage."
  },

  // Shower Systems - Rain Shower
  {
    id: 162,
    name: "Rain Shower Panel",
    category: "shower",
    type: "Rain Shower",
    image: "/images/newProducts/rainshower/1.jpg",
    description: "Premium rain shower panel with multiple spray patterns and massage jets."
  },
  {
    id: 163,
    name: "Rain Shower Head",
    category: "shower",
    type: "Rain Shower",
    image: "/images/newProducts/rainshower/2.jpg",
    description: "Large rain shower head delivering gentle rainfall simulation."
  },

  // Shower Systems - Telephonic Shower
  {
    id: 164,
    name: "Telephonic Hand Shower",
    category: "shower",
    type: "Hand Shower",
    image: "/images/newProducts/telephonicshower/1.jpg",
    description: "Ergonomic telephonic hand shower with multiple spray modes."
  },
  {
    id: 165,
    name: "Telephonic Shower Set",
    category: "shower",
    type: "Hand Shower Set",
    image: "/images/newProducts/telephonicshower/2.jpg",
    description: "Complete telephonic shower set with holder and flexible hose."
  },

  // Health Faucets
  {
    id: 166,
    name: "Health Faucet Chrome",
    category: "healthfaucet",
    type: "Health Faucet",
    image: "/images/newProducts/healthfaucets/1.jpg",
    description: "Chrome-plated health faucet with ergonomic grip and precise water control."
  },
  {
    id: 167,
    name: "Health Faucet Premium",
    category: "healthfaucet",
    type: "Health Faucet",
    image: "/images/newProducts/healthfaucets/2.jpg",
    description: "Premium health faucet with anti-bacterial coating and leak-proof design."
  },

  // Bathroom Accessories - Towel Rails
  {
    id: 168,
    name: "Towel Rail Single",
    category: "accessories",
    type: "Towel Rail",
    image: "/images/newProducts/towelrails/1.jpg",
    description: "Single bar towel rail with sturdy mounting and rust-resistant finish."
  },
  {
    id: 169,
    name: "Towel Rail Double",
    category: "accessories",
    type: "Towel Rail",
    image: "/images/newProducts/towelrails/2.jpg",
    description: "Double bar towel rail providing extra hanging space for towels."
  },

  // Bathroom Accessories - Towel Ring
  {
    id: 170,
    name: "Towel Ring Round",
    category: "accessories",
    type: "Towel Ring",
    image: "/images/newProducts/towelring/1.jpg",
    description: "Round towel ring with polished chrome finish and easy installation."
  },
  {
    id: 171,
    name: "Towel Ring Square",
    category: "accessories",
    type: "Towel Ring",
    image: "/images/newProducts/towelring/2.jpg",
    description: "Square towel ring with contemporary design and durable construction."
  },

  // Bathroom Accessories - Soap Dish
  {
    id: 172,
    name: "Soap Dish Wall Mount",
    category: "accessories",
    type: "Soap Dish",
    image: "/images/newProducts/soapdish/1.jpg",
    description: "Wall-mounted soap dish with drainage holes and easy cleaning."
  },
  {
    id: 173,
    name: "Soap Dish Corner",
    category: "accessories",
    type: "Soap Dish",
    image: "/images/newProducts/soapdish/2.jpg",
    description: "Corner soap dish maximizing space efficiency in compact bathrooms."
  },

  // Bathroom Accessories - Glass Shelf
  {
    id: 174,
    name: "Glass Shelf Single",
    category: "accessories",
    type: "Glass Shelf",
    image: "/images/newProducts/glassshelf/1.jpg",
    description: "Tempered glass shelf with chrome brackets for bathroom storage."
  },
  {
    id: 175,
    name: "Glass Shelf Double",
    category: "accessories",
    type: "Glass Shelf",
    image: "/images/newProducts/glassshelf/2.jpg",
    description: "Double-tier glass shelf providing ample storage for toiletries."
  },

  // Plumbing Fittings - Bottle Trap
  {
    id: 176,
    name: "Bottle Trap Chrome",
    category: "plumbing",
    type: "Bottle Trap",
    image: "/images/newProducts/bottletrap/1.jpg",
    description: "Chrome-finished bottle trap with easy-clean design and leak-proof seal."
  },
  {
    id: 177,
    name: "Bottle Trap Square",
    category: "plumbing",
    type: "Bottle Trap",
    image: "/images/newProducts/bottletrap/2.jpg",
    description: "Square bottle trap with modern aesthetics and efficient drainage."
  },

  // Plumbing Fittings - Connection Pipe
  {
    id: 178,
    name: "Connection Pipe Flexible",
    category: "plumbing",
    type: "Connection Pipe",
    image: "/images/newProducts/connectionpipe/1.jpg",
    description: "Flexible connection pipe for easy installation and maintenance."
  },
  {
    id: 179,
    name: "Connection Pipe Rigid",
    category: "plumbing",
    type: "Connection Pipe",
    image: "/images/newProducts/connectionpipe/2.jpg",
    description: "Rigid connection pipe with precise threading and durable construction."
  },

  // Plumbing Fittings - Extension Nipples
  {
    id: 180,
    name: "Extension Nipple Short",
    category: "plumbing",
    type: "Extension Nipple",
    image: "/images/newProducts/extensionnipples/1.jpg",
    description: "Short extension nipple for connecting pipes at various distances."
  },
  {
    id: 181,
    name: "Extension Nipple Long",
    category: "plumbing",
    type: "Extension Nipple",
    image: "/images/newProducts/extensionnipples/2.jpg",
    description: "Long extension nipple for extended reach plumbing connections."
  },

  // Plumbing Fittings - Waste Coupling
  {
    id: 182,
    name: "Waste Coupling Standard",
    category: "plumbing",
    type: "Waste Coupling",
    image: "/images/newProducts/wastecoupling/1.jpg",
    description: "Standard waste coupling for secure pipe connections and drainage."
  },
  {
    id: 183,
    name: "Waste Coupling Heavy Duty",
    category: "plumbing",
    type: "Waste Coupling",
    image: "/images/newProducts/wastecoupling/2.jpg",
    description: "Heavy-duty waste coupling for high-flow drainage applications."
  },

  // Drainage - Gratings
  {
    id: 184,
    name: "Floor Grating Square",
    category: "drainage",
    type: "Floor Grating",
    image: "/images/newProducts/gratings/1.jpg",
    description: "Square floor grating with anti-clog design and stainless steel construction."
  },
  {
    id: 185,
    name: "Floor Grating Round",
    category: "drainage",
    type: "Floor Grating",
    image: "/images/newProducts/gratings/2.jpg",
    description: "Round floor grating with decorative pattern and efficient water drainage."
  },

  // Angle Cocks
  {
    id: 186,
    name: "Angle Cock Chrome",
    category: "plumbing",
    type: "Angle Cock",
    image: "/images/newProducts/projectanglecock/1.jpg",
    description: "Chrome-plated angle cock for water supply control and shut-off."
  },
  {
    id: 187,
    name: "Angle Cock Brass",
    category: "plumbing",
    type: "Angle Cock",
    image: "/images/newProducts/projectanglecock/2.jpg",
    description: "Brass angle cock with superior durability and corrosion resistance."
  },

  // Allied Items
  {
    id: 188,
    name: "Allied Bathroom Fitting Set",
    category: "accessories",
    type: "Complete Set",
    image: "/images/newProducts/allieditems/1.jpg",
    description: "Complete bathroom fitting set with all essential accessories included."
  },
  {
    id: 189,
    name: "Allied Premium Kit",
    category: "accessories",
    type: "Premium Kit",
    image: "/images/newProducts/allieditems/2.jpg",
    description: "Premium allied kit with coordinated accessories for luxury bathrooms."
  }
];

// Category mappings for easier filtering
export const categories = {
  all: 'All Products',
  toilet: 'Toilet Seats',
  basin: 'Wash Basins', 
  luxury: 'Luxury Collection',
  classic: 'Classic Design',
  modern: 'Modern Collection',
  designer: 'Designer Series',
  compact: 'Compact Size',
  rimless: 'Rimless Technology',
  pedestal: 'Pedestal Design',
  italian: 'Italian Collection',
  european: 'European Style',
  concealed: 'Concealed Cistern',
  faucet: 'Faucets & Mixers',
  shower: 'Shower Systems',
  healthfaucet: 'Health Faucets',
  accessories: 'Bathroom Accessories',
  plumbing: 'Plumbing Fittings',
  drainage: 'Drainage Solutions'
};

// Get products by category
export const getProductsByCategory = (category) => {
  if (category === 'all') return productsData;
  return productsData.filter(product => product.category === category);
};

// Get featured products for hero section
export const getFeaturedProducts = () => {
  return [
    productsData.find(p => p.name === 'Audi'), // Luxury
    productsData.find(p => p.name === 'Element Rimless'), // Rimless
    productsData.find(p => p.name === 'ITA'), // Italian
    productsData.find(p => p.name === 'Ultra'), // Ultra Modern
  ].filter(Boolean);
};
